import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const CameraIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 29 28",
  path: (
    <>
      <Path
        d="M1.1665 10.1696C1.1665 9.7025 1.1665 9.46895 1.18599 9.27224C1.37397 7.37498 2.87486 5.87409 4.77212 5.68612C4.96883 5.66663 5.21498 5.66663 5.70728 5.66663C5.89698 5.66663 5.99182 5.66663 6.07235 5.66175C7.10065 5.59947 8.00111 4.95046 8.38536 3.99462C8.41546 3.91977 8.44358 3.83539 8.49984 3.66663C8.55609 3.49786 8.58422 3.41348 8.61431 3.33863C8.99857 2.38279 9.89902 1.73378 10.9273 1.6715C11.0079 1.66663 11.0968 1.66663 11.2747 1.66663H17.725C17.9029 1.66663 17.9918 1.66663 18.0724 1.6715C19.1007 1.73378 20.0011 2.38279 20.3854 3.33863C20.4155 3.41348 20.4436 3.49786 20.4998 3.66663C20.5561 3.83539 20.5842 3.91977 20.6143 3.99462C20.9986 4.95046 21.899 5.59947 22.9273 5.66175C23.0079 5.66663 23.1027 5.66663 23.2924 5.66663C23.7847 5.66663 24.0308 5.66663 24.2276 5.68612C26.1248 5.87409 27.6257 7.37498 27.8137 9.27224C27.8332 9.46895 27.8332 9.7025 27.8332 10.1696V20.6C27.8332 22.8402 27.8332 23.9603 27.3972 24.8159C27.0137 25.5686 26.4018 26.1805 25.6491 26.564C24.7935 27 23.6734 27 21.4332 27H7.5665C5.32629 27 4.20619 27 3.35054 26.564C2.59789 26.1805 1.98597 25.5686 1.60248 24.8159C1.1665 23.9603 1.1665 22.8402 1.1665 20.6V10.1696Z"
        stroke="#9CB0F8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.4998 21C17.4454 21 19.8332 18.6121 19.8332 15.6666C19.8332 12.7211 17.4454 10.3333 14.4998 10.3333C11.5543 10.3333 9.1665 12.7211 9.1665 15.6666C9.1665 18.6121 11.5543 21 14.4998 21Z"
        stroke="#9CB0F8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export { CameraIcon };
